import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import ChallengeListPage from "src/components/events/challenge/challengeList";
import { RODEO_PAGE_NAME, APPLICATION_NAME } from "src/_config";

export default function ChallengeListContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Challenges`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.CHALLENGE_LIST} />
        <ChallengeListPage />
      </section>
    </React.Fragment>
  );
}
